import { ApiConfigurationService } from './api-configuration.service';
import { Configuration } from "./client";
import { Injectable, inject, effect } from '@angular/core';

/**
 * API Configuration for V2 endpoints.
 * Uses the shared ApiConfigurationService for base path management.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration extends Configuration {
  private readonly configService = inject(ApiConfigurationService);

  constructor() {
    super();

    // Set the initial basePath synchronously so that services injecting
    // Configuration via DI see a valid value before the first effect run —
    // otherwise the OpenAPI-generated constructors fall back to the default
    // 'http://localhost' and that value sticks until the effect runs.
    this.basePath = this.configService.getBasePath();

    // Keep basePath in sync with ApiConfigurationService using effect
    effect(() => {
      this.basePath = this.configService.basePath();
    });
  }
}
